export const AI_QUESTIONS = [
  'Any weekend activity for kids?',
  'बच्चों के लिए कोई वीकेंड एक्टिविटी?',
  'বাচ্চাদের জন্য সপ্তাহান্তে কিছু আছে?',
  'ಮಕ್ಕಳಿಗೆ ವಾರಾಂತ್ಯದ ಚಟುವಟಿಕೆ ಇದೆಯಾ?'
];

export const FEATURE_QUESTIONS = {
  groups: [
    'What groups are there for sports?',
    'Any book clubs in my area?',
    'Where can I find hiking groups?',
    'Are there any parenting groups?'
  ],
  events: [
    'What can I do this weekend with my 4 year old?',
    'Any free events happening today?',
    'Show me all events?',
    'What workshops are available this month?'
  ],
  services: [
    'Who can help me fix my bike?',
    'Need a reliable house cleaner',
    'Looking for a dog walker nearby',
    'Any tutors for math available?'
  ],
  marketplace: [
    'Anyone selling a kids bicycle?',
    'Looking for used furniture',
    'Who has plants for sale?',
    'Any electronics available?'
  ]
};
